import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "thumb", "counter"];

  connect() {
    this.index = 0;
  }

  prev() {
    this.show(this.index - 1);
  }

  next() {
    this.show(this.index + 1);
  }

  goTo(event) {
    this.show(parseInt(event.currentTarget.dataset.index, 10));
  }

  show(nextIndex) {
    const total = this.slideTargets.length;
    if (total === 0) return;

    this.index = (nextIndex + total) % total;

    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== this.index);
    });

    this.thumbTargets.forEach((thumb, i) => {
      thumb.classList.toggle("offer-gallery__thumb--active", i === this.index);
    });

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.index + 1} / ${total}`;
    }
  }
}
